<template>
  <div class="table-responsive">
    <table class="table table-striped table-vcenter">
      <thead>
        <tr>
          <th
            :class="[
              column.class,
              {
                sorting: column.sort,
                sorting_asc: sortColumn === column.key && sortDirection === 'asc',
                sorting_desc: sortColumn === column.key && sortDirection === 'desc',
              },
            ]"
            v-on:click.prevent="sort(column)"
            v-for="column in columns"
            :key="column.name"
            :data-toggle="column.tooltip ? 'tooltip' : ''"
            data-placement="top"
            :title="column.tooltip ? column.tooltip : ''"
            :data-original-title="column.tooltip ? column.tooltip : ''"
          >
            {{ column.name | capitalize }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index">
          <td :class="column.class" v-for="column in columns" :key="`${index}_${column.name}`">
            <slot :name="column.name.replace(/\s+/g, '-')" v-bind:props="row">
              {{ $_.get(row, column.key) }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    columns: {
      type: Array,
      required: true,
      default: () => [],
    },
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    preset_column: {
      type: String,
      required: false,
      default: null
    },
    preset_direction: {
      type: String,
      required: false,
      default: null
    }
  },
  watch: {
    data: function() {
      this.rows;
    }
  },
  computed: {
    rows: function() {
      var rows = _.sortBy(this.data, this.sortColumn);
      return this.sortDirection == 'desc' ? _.reverse(rows) : rows;
    },
  },
  data: function() {
    return {
      sortColumn: this.preset_column ? this.preset_column : this.columns[0].key,
      sortDirection: this.preset_direction ? this.preset_direction : 'asc',
    };
  },
  mounted() {
    if (this.preset_column) this.sort({key: this.preset_column});
  },
  methods: {
    sort: function(column) {
      if (this.sortColumn === column.key) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortDirection = 'asc';
        this.sortColumn = column.key;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  thead {
    th {
      &.sorting {
        position: relative;
        cursor: pointer;

        &::after {
          content: '\f0dc';
          position: absolute;
          right: 0.375rem;
          bottom: 0.75rem;
          font-family: 'Font Awesome 5 Free';
          font-weight: 600;
          opacity: 0.4;
        }

        &.sorting_asc {
          &::after {
            content: '\f106';
          }
        }

        &.sorting_desc {
          &::after {
            content: '\f107';
          }
        }
      }
    }
  }
}
</style>
